<template>
  <div class="nav__content">
    <ul class="nav__list">
      <li class="nav__list-item" @click="$store.commit('toggleNav')">
        <router-link to="/">
          {{ T('home') }}
        </router-link>
      </li>
      <li class="nav__list-item" @click="$store.commit('toggleNav')">
        <router-link to="/about">
          {{ T('about') }}
        </router-link>
      </li>
      <li class="nav__list-item" @click="$store.commit('toggleNav')">
        <router-link to="/projects">
          {{ T('projects') }}
        </router-link>
      </li>
      <li class="nav__list-item" @click="$store.commit('toggleNav')">
        <router-link to="/contacts">
          {{ T('contacts') }}
        </router-link>
      </li>
    </ul>
    <ul class="nav__list mt-10 text-sm">
      <li class="nav__list-item cursor-pointer" @click="$store.commit('setLocale','en')">
        <span class="text-xs hover:text-primary">EN</span>
      </li>
      <li class="nav__list-item cursor-pointer" @click="$store.commit('setLocale','bg')">
        <span class="text-xs hover:text-primary">BG</span>
      </li>
    </ul>
  </div>
</template>
<script>

    export default {
        name: 'Navigation'
    }
</script>

<style lang="scss" scoped>

</style>
